export default __webpack_public_path__ + "static/media/team-player-icon.d1127186.svg";